import * as at from './actionTypes'

export const updateBarleyCost = (barleyCost) => ({
  type: at.UPDATE_BARLEY_COST,
  payload: {data: {key: 'barleyCost', value: barleyCost}},
})

export const registerUser = (data) => ({
  type: at.USER_REGISTER,
  payload: {data},
})

export const loginUser = (data) => {
  return {type: at.USER_LOGIN, payload: data}
}

export const updateUserData = (data) => {
  return {type: at.USER_DATA_UPDATE, payload: data}
}

export const logoutUser = (data) => {
  return {type: at.USER_LOGOUT, payload: data}
}

export const resetDefaults = () => {
  return {type: at.USER_RESET_DEFAULTS, payload: null}
}

export const updateIsLoggedIn = (isLoggedIn) => ({
  type: at.UPDATE_LOGIN,
  payload: {isLoggedIn},
})

// Update Loading Feed Data
export const updateIsFetchingFeedData = (isLoading) => ({
  type: at.FETCHING_FEED_DATA,
  payload: {isLoading},
})

// Wipe all users defaults, backgrounders, finishings, and price projections
export const clearUserData = () => ({
  type: at.USER_CLEAR_DATA,
  payload: null,
})

// Update Feed Data
export const updateFeedData = (data) => ({
  type: at.UPDATE_DATA,
  payload: {data},
})

// ToS
export const updateUserAcceptedToS = () => ({
  type: at.USER_ACCEPTED_TOS,
  payload: true,
})

export const replaceAllDefaults = (data) => ({
  type: at.REPLACE_ALL_DEFAULTS,
  payload: {data},
})

// Backgrounder
export const saveBackgrounder = (data) => ({
  type: at.BACKGROUNDER_SAVE,
  payload: {data},
})

export const updateBackgrounder = (data) => ({
  type: at.BACKGROUNDER_UPDATE,
  payload: {data},
})

export const deleteBackgrounder = (id) => ({
  type: at.BACKGROUNDER_DELETE,
  payload: {id},
})

export const updateDefaultNumberBackgrounder = (data) => ({
  type: at.BACKGROUNDER_UPDATE_DEFAULT_NUMBER,
  payload: {data},
})

// Update Finishings
export const saveFinishing = (data) => ({
  type: at.FINISHING_SAVE,
  payload: {data},
})

export const updateFinishing = (data) => ({
  type: at.FINISHING_UPDATE,
  payload: {data},
})

export const deleteFinishing = (id) => ({
  type: at.FINISHING_DELETE,
  payload: {id},
})

export const updateDefaultNumberFinishing = (data) => ({
  type: at.FINISHING_UPDATE_DEFAULT_NUMBER,
  payload: {data},
})

// Update Price Projection
export const saveProjection = (data) => ({
  type: at.PROJECTION_SAVE,
  payload: {data},
})

export const updateProjection = (data) => ({
  type: at.PROJECTION_UPDATE,
  payload: {data},
})

export const deleteProjection = (id) => ({
  type: at.PROJECTION_DELETE,
  payload: {id},
})



// WEBPACK FOOTER //
// ./src/actions.js